export const URL_PREFIX = '/api';

export default {
  URL_PREFIX,
};
